module.exports = __webpack_public_path__ + "img/tag_percent.dfcf3fb7.svg";